export * from './types';
export * from '../../../common/Node/Anchor/Anchor';

import ToolConfig, { Tool } from './Standard/Tool/Tool';
import CompletionConfig, { Completion } from './Standard/Completion/Completion';
import BranchConfig, { Branch } from './Logic/Branch/Branch';
import JumpToConfig, { JumpTo } from './Logic/JumpTo/JumpTo';
import RequestConfig, { Request } from './Trigger/Request/Request';
import ResponseConfig, { Response } from './Standard/Response/Response';
import SwitchConfig, { Switch } from './Logic/Switch/Switch';
import HTTPConfig, { HTTPClient } from './Standard/HTTP/HTTP';
import ModuleConfig, { Module } from './Trigger/Module/Module';
import ModNodeConfig, { ModNode } from './Standard/ModNode/ModNode';
import InboundCallConfig, { InboundCall } from './Trigger/InboundCall/InboundCall';
import HangupCallConfig, { HangupCall } from './CallControl/HangupCall/HangupCall';
import AnswerCallConfig, { AnswerCall } from './CallControl/AnswerCall/AnswerCall';
import SpeakTextConfig, { SpeakText } from './CallControl/SpeakText/SpeakText';
import TranscriptionStartConfig, { TranscriptionStart } from './CallControl/TranscriptionStart/TranscriptionStart';
import TranscriptionStopConfig, { TranscriptionStop } from './CallControl/TranscriptionStop/TranscriptionStop';
import GatherUsingAIConfig, { GatherUsingAI } from './CallControl/GatherUsingAI/GatherUsingAI';
import PlaybackStartConfig, { PlaybackStart } from './CallControl/PlaybackStart/PlaybackStart';
import PlaybackStopConfig, { PlaybackStop } from './CallControl/PlaybackStop/PlaybackStop';
import NoiseSuppressionConfig, { NoiseSuppression } from './CallControl/NoiseSuppression/NoiseSuppression';
import StoreMessageNodeConfig, { StoreMessage } from './StoreMessage/StoreMessage';
import DelayNodeConfig, { Delay } from './Utilities/Delay/Delay';
import Base64TransformerNodeConfig, { Base64Transformer } from './Utilities/Base64Transformer/Base64Transformer';
import DateTimeConfig, { DateTime } from './Utilities/Datetime/DateTime';
import DialConfig, { Dial } from './CallControl/Dial/Dial';
import TransferCallConfig, { TransferCall } from './CallControl/TransferCall/TransferCall';
import RejectCallConfig, { RejectCall } from './CallControl/RejectCall/RejectCall';
import StreamingStartConfig, { StreamingStart } from './CallControl/StreamingStart/StreamingStart';
import StreamingStopConfig, { StreamingStop } from './CallControl/StreamingStop/StreamingStop';
import InboundMessageConfig, { InboundMessage } from './Trigger/InboundMessage/InboundMessage';
import SendMessageConfig, { SendMessage } from './Messaging/SendMessage/SendMessage';
import BridgeConfig, { Bridge } from './CallControl/Bridge/Bridge';
import RecordingStartConfig, { RecordingStart } from './CallControl/RecordingStart/RecordingStart';
import RecordingStopConfig, { RecordingStop } from './CallControl/RecordingStop/RecordingStop';
import RecordingResumeConfig, { RecordingResume } from './CallControl/RecordingResume/RecordingResume';
import RecordingPauseConfig, { RecordingPause } from './CallControl/RecordingPause/RecordingPause';
import AssistantRouterConfig, { AssistantRouter } from './Standard/AssistantRouter/AssistantRouter';
import AssistantConfig, { Assistant } from './Standard/Assistant/Assistant';

import NoiseSuppressionStopConfig, {
  NoiseSuppressionStop,
} from './CallControl/NoiseSuppressionStop/NoiseSuppressionStop';

import { NodeTypes } from 'reactflow';
import { AnchorType } from '../types';

export const config: { [key: string]: any } = {
  Tool: ToolConfig,
  Completion: CompletionConfig,
  Branch: BranchConfig,
  Switch: SwitchConfig,
  JumpTo: JumpToConfig,
  Request: RequestConfig,
  Response: ResponseConfig,
  HTTPClient: HTTPConfig,
  Module: ModuleConfig,
  ModNode: ModNodeConfig,
  InboundCall: InboundCallConfig,
  HangupCall: HangupCallConfig,
  AnswerCall: AnswerCallConfig,
  SpeakText: SpeakTextConfig,
  TranscriptionStart: TranscriptionStartConfig,
  GatherUsingAI: GatherUsingAIConfig,
  TranscriptionStop: TranscriptionStopConfig,
  PlaybackStart: PlaybackStartConfig,
  PlaybackStop: PlaybackStopConfig,
  NoiseSuppression: NoiseSuppressionConfig,
  NoiseSuppressionStop: NoiseSuppressionStopConfig,
  StoreMessage: StoreMessageNodeConfig,
  Delay: DelayNodeConfig,
  Base64Transformer: Base64TransformerNodeConfig,
  DateTime: DateTimeConfig,
  Dial: DialConfig,
  RejectCall: RejectCallConfig,
  TransferCall: TransferCallConfig,
  StreamingStart: StreamingStartConfig,
  StreamingStop: StreamingStopConfig,
  InboundMessage: InboundMessageConfig,
  SendMessage: SendMessageConfig,
  Bridge: BridgeConfig,
  RecordingStart: RecordingStartConfig,
  RecordingStop: RecordingStopConfig,
  RecordingPause: RecordingPauseConfig,
  RecordingResume: RecordingResumeConfig,
  AssistantRouter: AssistantRouterConfig,
  Assistant: AssistantConfig,
};

export const nodeTypes: NodeTypes = {
  Tool,
  Completion,
  Branch,
  Switch,
  JumpTo,
  Request,
  Response,
  HTTPClient,
  Module,
  ModNode,
  InboundCall,
  HangupCall,
  AnswerCall,
  SpeakText,
  TranscriptionStart,
  GatherUsingAI,
  TranscriptionStop,
  PlaybackStart,
  PlaybackStop,
  NoiseSuppression,
  NoiseSuppressionStop,
  StoreMessage,
  Delay,
  Base64Transformer,
  DateTime,
  Dial,
  RejectCall,
  TransferCall,
  StreamingStart,
  StreamingStop,
  InboundMessage,
  SendMessage,
  Bridge,
  RecordingStart,
  RecordingStop,
  RecordingPause,
  RecordingResume,
  AssistantRouter,
  Assistant,
};

export const pairedNodes: { [key: string]: string } = {
  Request: 'Response',
};

export const triggerExecutionSources = Object.keys(config)
  .map((key) => {
    const { anchors, trigger } = config[key].config;

    if (trigger)
      return anchors
        .filter((anchor: AnchorType) => anchor.type === 'source' && anchor.variant.includes('execution'))
        .map((anchor: AnchorType) => anchor.id);
    return [];
  })
  .flat(5);
